<template>
    <div class="d-flex align-center">
        <v-card class="preaty__card" @click="$emit('show-detail')" :style="showErrors && !stage.validate()? 'border: 2px solid rgba(220, 11, 11, 0.898);': 'border: 1px solid var(--v-primary_blue-base);'">
            <v-card-title class="pt-1">
                <v-row class="d-flex ml-0">
                    <v-col class="pa-0 ma-0" cols="8">
                        <div v-if="stage && stage.nickname === ''">
                            <h5 class="text__balance">{{formatField(stage.name)}}</h5>
                        </div>
                        <div v-else-if="stage && stage.nickname !== ''">
                            <h5 class="text__balance">{{stage.nickname}}</h5>
                        </div>
                    </v-col>
                    <v-col cols="2" class="d-flex justify-left pa-0 ma-0">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    style="margin-right: 5px;"
                                    class="custom-toggle-btn"
                                    elevation="2"
                                    variant="text"
                                    icon
                                    @click.stop="stage.persist = !stage.persist">
                                    <v-icon v-if="stage.persist" color="var(--v-primary-base)">mdi-timer-sand</v-icon>
                                    <v-icon v-else color="#0000008a">mdi-timer-sand</v-icon>
                                </v-btn>
                            </template>
                            Activa o desactiva la persistencia de mis registros
                        </v-tooltip>
                    </v-col>
                    <v-col cols="1" class="d-flex justify-end pa-0 ma-0">
                        <v-btn
                            style="margin-right: 5px;"
                            class="custom-toggle-btn"
                            :color="!stage.visible ? 'gray' : 'primary'"
                            elevation="2"
                            variant="text"
                            icon
                            @click.stop="stage.visible = !stage.visible">
                            <v-icon>{{ !stage.visible ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
                            <!-- {{ show_custom_prompt ? ' Hide Prompt' : ' Customizar Prompt' }} -->
                        </v-btn>
                    </v-col>
                    <v-col cols="1" class="d-flex justify-end pa-0 ma-0">
                        <v-btn icon @click.stop="removeStage">
                            <v-icon small class="material-symbols-outlined">close</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-subtitle class="d-flex ml-0" v-if="stage.label">
                <h5 class="text__balance"><i>{{stage.label}}</i></h5>
            </v-card-subtitle>
            <v-card-text>
            <v-row v-if="stage.name == 'WaitForApproval'" class="ml-0">
                <v-col class="pa-0 ma-0" v-if="stage.username_location">
                    <span> Ruta al usuario: <strong>{{stage.username_location.replace('hardcoded.','')}}</strong></span>
                </v-col>
                <v-col class="pa-0 ma-0" v-else>
                    <span> Usuario: <strong>{{stage.username}}</strong></span>
                </v-col>
            </v-row>
            <v-row v-if="['RunCommand'].includes(stage.name) " class="ml-0">
                <v-col class="pa-0 ma-0">
                    <span> Comando: <strong>{{stage.cmd_name}}</strong></span>
                </v-col>
            </v-row>
            <v-row v-if="['RunQuery'].includes(stage.name) " class="ml-0">
                <v-col class="pa-0 ma-0">
                    <span> Query: <strong>{{stage.query_name}}</strong></span>
                </v-col>
            </v-row>
            <v-row v-if="['RunWorkflow'].includes(stage.name) " class="ml-0">
                <v-col class="pa-0 ma-0">
                    <span> Workflow: <strong>{{stage.workflow_template_id}}</strong></span>
                </v-col>
            </v-row>
            <v-row v-if="['RunCommand','RunQuery', 'RunWorkflow','LookupAndMatchInstance','AskAI','ExtractInstanceFromRawData','CreateInstanceFromContext','CreateInstance','RunScript', 'CompleteConversation'].includes(stage.name) " class="ml-0">
                <v-col class="pa-0 ma-0">
                    <span> Clave de guardado: <strong>{{stage.save_as_key}}</strong></span>
                </v-col>
            </v-row>
            <v-row v-if="['LookupAndMatchMultipleInstances','CreateInstancesFromList', 'SplitFile'].includes(stage.name) " class="ml-0">
                <v-col class="pa-0 ma-0">
                    <span> Clave de guardado: <strong>{{stage.save_list_key}}</strong></span>
                </v-col>
            </v-row>
            <v-row v-if="['AddInstanceToList'].includes(stage.name) " class="ml-0">
                <v-col class="pa-0 ma-0">
                    <span> Lista modificada: <strong>{{stage.list_location}}</strong></span>
                </v-col>
            </v-row>
            <v-row v-if="['RunCommand','RunQuery', 'RunWorkflow', 'LookupAndMatchInstance','AskAI','ExtractInstanceFromRawData','CreateInstanceFromContext',
            'CreateInstance','RunScript','CreateInstancesFromList', 'LookupAndMatchMultipleInstances','AddInstanceToList'].includes(stage.name) " class="ml-0">
                <v-col class="pa-0 ma-0">
                    <span> Tipo registro salida: <strong>{{ type_id_to_name[stage.entity_type_id]}}</strong></span>
                </v-col>
            </v-row>
            <v-row v-if="['SendThroughEmail','SendEmailWithTemplate'].includes(stage.name)" class="ml-0">
                <v-col class="pa-0 ma-0">
                    <span> Ruta al email: <strong>{{stage.email_location.replace('hardcoded.','')}}</strong></span>
                </v-col>
            </v-row>
            <v-row v-if="stage.name == 'PayrollAccounting'" class="ml-0">
                <v-col class="pa-0 ma-0">
                    <span> Descripción: <strong>{{stage.description}}</strong></span>
                </v-col>
            </v-row>
            <v-row v-if="stage.name == 'SendDataToEndpoint'" class="ml-0">
                <v-col class="pa-0 ma-0">
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <span v-on="on"> 
                                Endpoint: 
                                <strong>
                                    {{stage.endpoint.slice(0,34)}}<template v-if="stage.endpoint.length>34">...</template>
                                </strong>
                            </span>
                        </template>
                        <span>{{stage.endpoint}}</span>
                    </v-tooltip>
                </v-col>
            </v-row>
            <v-row class="ml-0">
                <v-col class="pa-0 ma-0">
                    <span> Precio: <strong>{{stage.price}} créditos</strong></span>
                </v-col>
            </v-row>
           
            </v-card-text>
            <div cols="1" style="position:absolute;bottom:0px;right:0px" class="d-flex justify-end pa-0 ma-0">
                <slot name="custom-content"></slot>
            </div>
            <div cols="1" style="position:absolute;bottom:0px;left:0px" class="d-flex justify-end pa-0 ma-0">
                <slot name="custom-content-left"></slot>
            </div>
        </v-card>
        <v-icon v-if="!last" class="ml-1 material-symbols-outlined" color="primary_blue">trending_flat</v-icon>
        <v-btn class="ml-1" color="primary_blue" @click="addStage" icon v-if="last">
            <v-icon class="material-symbols-outlined">add</v-icon>
        </v-btn>
    </div>
</template>

<script>
import { Stage } from '@/modules/document/domain/WorkflowTemplate';
import { DOCS_FIELD_MAP_SHOW } from "@/modules/document/domain/Document";
export default {
    name:'WorkflowTemplateStageCard',
    props:{
        stage: {
            type: Stage,
            default: false,
        },
        showErrors: {
            type: Boolean,
            default: false
        },
        available_types: {
            type: Array,
            default: () => []
        },
        last: {
            type: Boolean,
            default: false
        },
    },
    data(){
        return {
            
        }
    },
    mounted(){
        console.log(this.last)
    },
    methods:{
        formatField(field) {
            return DOCS_FIELD_MAP_SHOW[field] || field;
        },
        addStage(){
            this.$emit('add-stage');
        },
        removeStage(){
            this.$emit('remove-stage');
        }
    },
    computed:{
        type_id_to_name(){
            let dic = {};
            this.available_types.forEach(type => {
                dic[type.uuid] = type.name;
            });
            return dic;
        }
    }
}
</script>

<style scoped>
.text__balance {
    text-wrap: balance;
}
.preaty__card {
    /*border: 1px solid var(--v-primary_blue-base);*/
    width: 350px;
    height: 180px;
    border-radius: 5px;
    margin-bottom: 10px;
}
.error--text {
    color: rgba(220, 11, 11, 0.898) !important;
}
</style>